module.exports = __webpack_public_path__ + "img/BRCA1_CD8Tex.d491f80f.png";